import { CurrencyCircleDollar as CurrencyIcon } from "@phosphor-icons/react";

export default CurrencyIcon
